// © Microsoft Corporation. All rights reserved.

export const enums = {
    selectPpeParameter: "oneservice_enable_ppe",
    flights: {
        contentCommentsOnly: "prg-comv2"
    },
    externalUrls: {
        api: "https://api.msn.com/community/",
        ppeApi: "https://ppe-api.msn.com/community/",
        guidelinePage: "https://www.msn.com/en-us/community/guideline",
        guidelinePageEmbed: "https://www.msn.com/en-us/community/embed/guidelinepage",
        profilePage: "https://www.msn.com/en-us/community/profile/",
        channelPage: "https://www.msn.com/en-us/community/channel/",
        privacySettings: "https://www.msn.com/en-us/settings",
        profileSettings: "https://account.microsoft.com/profile",
        feedbackForm: "https://forms.office.com/Pages/ResponsePage.aspx?id=v4j5cvGGr0GRqy180BHbR-V3gf69zQlBm1dJVuXA8mtURVI4UlFHMDRIR0VCWDFWNUQyQU5HVzJJQi4u",
        moderationEmail: "Appealsprocessor@microsoft.com",
        newPost: "https://www.msn.com/en-us/community/post/new"
    },
    userStateType: {
        existingUser: "existingUser",
        anonymous: "anonymous",
        newUser: "newUser"
    },
    userNameStatusType: {
        normal: "Normal",
        notAllow: "NotAllow",
        inReview: "InReview",
        unknown: "Unknown"
    },
    userAvatarStatusType: {
        normal: "Normal",
        notAllow: "NotAllow",
        inReview: "InReview",
        unknown: "Unknown"
    },
    userAgeGroup: {
        under18: "Under18",
        above18: "Above18"
    },
    activityType: {
        follow: "Follow",
        reply: "Reply",
        reaction: "Reaction",
        badge: "Achievement",
        moderation: "Moderation",
        commentDeleteAlert: "CommentDeleteAlert",
        profileBannedAlert: "ProfileBannedAlert",
        profileErrorAlert: "ProfileErrorAlert"
    },
    moderationErrorType: {
        takedown: "Takedown",
        ban: "Ban",
        notAllowName: "NotAllowName",
        notAllowPicture: "NotAllowPicture",
        approveUserAppeal: "ApproveUserAppeal",
        rejectUserAppeal: "RejectUserAppeal",
        approveProfilePicAppeal: "ApproveProfilePicAppeal",
        rejectProfilePicAppeal: "RejectProfilePicAppeal",
        approveCommentAppeal: "ApproveCommentAppeal",
        rejectCommentAppeal: "RejectCommentAppeal"
    },
    visibleStatusType: {
        Normal: "Normal",
        DeletedByUser: "DeletedByUser",
        DeletedByAI: "DeletedByAI",
        DeletedByHI: "DeletedByHI",
        InReview: "InReview"
    },
    visibleStatusMap: {
        DeletedByUser: "VisibleStatusDeletedByUser",
        DeletedByAI: "VisibleStatusDeletedByAI",
        DeletedByHI: "VisibleStatusDeletedByHI",
        InReview: "VisibleStatusInReview",
        Default: "VisibleStatusOther"
    },
    commentReportMap: {
        Spam: "ReportOptSpam",
        Profanity: "ReportOptProfanity",
        Abuse: "ReportOptAbuse",
        RiskyLowAuthority: "ReportOptRiskyLowAuthority",
        Copyright: "ReportOptCopyright",
        ChildRelated: "ReportOptChildRelated",
        Violent: "ReportOptViolent",
        Danger: "ReportOptDanger",
        PublicThreats: "ReportOptPublicThreats",
        Illegal: "ReportOptIllegal",
        Terrorism: "ReportOptTerrorism",
        Privacy: "ReportOptPrivacy",
        Inappropriate: "ReportOptInappropriate",
        OffTopic: "ReportOptOffTopic"
    },
    userNameReportMap: {
        Spam: "ReportOptSpam",
        Profanity: "ReportOptProfanity",
        Abuse: "ReportOptAbuse",
        RiskyLowAuthority: "ReportOptRiskyLowAuthority",
        ChildRelated: "ReportOptChildRelated",
        Violent: "ReportOptViolent",
        Danger: "ReportOptDanger",
        PublicThreats: "ReportOptPublicThreats",
        Illegal: "ReportOptIllegal",
        Terrorism: "ReportOptTerrorism",
        Privacy: "ReportOptPrivacy",
        Inappropriate: "ReportOptInappropriate",
        OffTopic: "ReportOptOffTopic"
    },
    userPictureReportMap: {
        Spam: "ReportOptSpam",
        Profanity: "ReportOptProfanity",
        Abuse: "ReportOptAbuse",
        RiskyLowAuthority: "ReportOptRiskyLowAuthority",
        Copyright: "ReportOptCopyright",
        ChildRelated: "ReportOptChildRelated",
        Violent: "ReportOptViolent",
        Danger: "ReportOptDanger",
        PublicThreats: "ReportOptPublicThreats",
        Illegal: "ReportOptIllegal",
        Terrorism: "ReportOptTerrorism",
        Privacy: "ReportOptPrivacy",
        Nudity: "ReportOptNudity",
        NonConsensualIntimateImagery: "ReportOptNonConsensualIntimateImagery",
        Inappropriate: "ReportOptInappropriate",
        OffTopic: "ReportOptOffTopic"
    },
    reactionOrder: [
        "like", "love", "surprised", "thinking", "sad", "angry"
    ],
    profileReportItemMap: {
        UserName: "ReportUserName",
        ProfilePicture: "ReportProfilePicture"
    },
    profilePageEmptyStates: {
        NoUser: "NoUser",
        NotSocialUser: "NotSocialUser"
    },
    reactionIconMap: {
        like: "EmojiLike",
        love: "EmojiHeart",
        thinking: "EmojiThinking",
        surprised: "EmojiSurprised",
        sad: "EmojiSad",
        angry: "EmojiAngry"
    },
    reactions: {
        like: "like",
        love: "love",
        thinking: "thinking",
        surprised: "surprised",
        sad: "sad",
        angry: "angry"
    },
    responsiveLevels: {
        L0: "cwtl-0",
        L1: "cwtl-1",
        L2: "cwtl-2",
        MobilePopup: "cwt-mobile-popup",
        articleOneBlock: "cwt-article-one-block"
    },
    newCommentErrorCodeMap: {
        400: "NewPostDeniedMsg",
        403: "NewPostSessionExpiredMsg",
        500: "NewPostWentWrongMsg",
        bodyTooLong: "NewPostTooLongMsg",
        other: "NewPostWentWrongMsg",
        0: "NewPostWentWrongMsg",
        1: "NewPostSessionExpiredMsg",
        4: "NewPostDeniedMsg",
        6: "NewPostWentWrongMsg",
        7: "NewPostWentWrongMsg",
        8: "NewPostWentWrongMsg",
        9: "NewPostWentWrongMsg",
        10: "NewPostWentWrongMsg",
        11: "NewPostWentWrongMsg",
        12: "NewPostTooManyCommentsMsg",
        20: "NewPostTooLongMsg",
        21: "NewPostMentionMsg",
        22: "NewPostWentWrongMsg",
        23: "NewPostWentWrongMsg",
        24: "NewPostDeniedMsg",
        25: "NewPostWentWrongMsg",
        26: "NewPostWentWrongMsg",
        27: "NewPostWentWrongMsg",
        28: "NewPostDeniedMsg",
        29: "NewPostDeniedMsg",
        30: "NewPostDeniedMsg",
        31: "NewPostDeniedMsg",
        32: {
            1: "NewPostDuplicatedMsg",
            2: "NewPostDeniedMsg",
            3: "NewPostDeniedMsg",
            4: "NewPostDeniedMsg",
            5: "NewPostDeniedMsg",
            6: "NewPostDeniedMsg",
            7: "NewPostDeniedMsg",
            8: "NewPostDeniedMsg",
            9: "NewPostDeniedMsg",
            10: "NewPostDeniedMsg",
            11: "NewPostDeniedMsg",
            12: "NewPostDeniedMsg",
            13: "NewPostDeniedMsg",
            14: "NewPostDeniedMsg",
            15: "NewPostDeniedMsg",
            16: "NewPostDeniedMsg",
            17: "NewPostLanguageErrorMsg",
            18: "NewPostURLMsg"
        }

    },
    commentsStatusType: {
        zero: 0,
        minimal: 1,
        expanded: 2,
        notDetermined: 3
    },
    theme: {
        default: {
            name: "default",
            disabledComponents: []
        },
        superappBase: {
            name: "superapp",
            disabledComponents: []
        },
        windowsBase: {
            name: "windows",
            disabledComponents: []
        },
        superappEmbed: {
            name: "superapp-embed",
            modalComponents: ["reactionbreakdowncomment", "reactionbreakdowncontent", "onboardingpage", "onboardingthirdpartypage", "onboardingunderagepage", "reportmenu", "profilereportmenu", "copyrightform", "trademarkform"],
            disabledComponents: ["profilepage", "guidelinepage", "articlepage", "multiloginpage", "reactionbreakdowncomment", "reactionbreakdowncontent", "onboardingpage", "onboardingthirdpartypage", "onboardingunderagepage", "notificationtray", "reportmenu", "profilereportmenu", "copyrightform", "trademarkform"]
        },
        superappFullpage: {
            name: "superapp-fullpage",
            modalComponents: ["reactionbreakdowncomment", "reactionbreakdowncontent", "onboardingpage", "onboardingthirdpartypage", "onboardingunderagepage", "reportmenu", "profilereportmenu", "copyrightform", "trademarkform"],
            disabledComponents: ["profilepage", "guidelinepage", "articlepage", "multiloginpage", "onboardingthirdpartypage", "notificationtray"]
        }
    },
    profileVisitedLocalStorageKey: "self-profile-visited"
};